import React, { Component } from 'react';
import { TabBar } from 'antd-mobile';
import DelegateMine from './DelegateMine';
import Constants from '../utils/Constants';
import StorageUtils from '../utils/StorageUtils';
import iconOrder from '../medias/icon-order.svg';
import iconOrderSelected from '../medias/icon-order-selected.svg';
import iconHome from '../medias/icon-home.svg';
import iconHomeSelected from '../medias/icon-home-selected.svg';
import iconMine from '../medias/icon-mine.svg';
import iconMineSelected from '../medias/icon-mine-selected.svg';
import DataFetcher from '../utils/DataFetcher';
import OrderOfDelegate from './OrderOfDelegate';
import HomeOfDelegate from './HomeOfDelegate';

const history = require("history").createHashHistory()

class Delegate extends Component {
    constructor(props){
        super(props);

        let selectedTab = StorageUtils.retrieveStringFromSession(Constants.Storage.DELEGATE_SELECTED_TAB);
        if (!selectedTab||selectedTab==='') {
            selectedTab = 'homeTab';
        }

        this.state = {
            selectedTab: selectedTab,
            delegateId: this.props.match.params.delegateId
        }
        
    }

    componentDidMount() {
        const { delegateId } = this.state
        DataFetcher.delegateProfile({
            id: delegateId
        },{
            success: (resp) => {
            },
            logicError: () => {
                history.replace("/about")
            },
            sysError: () => {
                history.replace("/about")
            }
        })
    }

    static getDerivedStateFromProps(nextProps, prevState) {
        if(nextProps.match.params.delegateId !== prevState.delegateId) {
            return {
                delegateId: nextProps.match.params.delegateId,
            }
        }
        return null
    }

    render() {
        const { selectedTab, delegateId } = this.state;
        StorageUtils.storeStringToSession(Constants.Storage.DELEGATE_SELECTED_TAB, selectedTab);
        
        return (
            <div className="app-container">
                <TabBar unselectedTintColor="#8a8a8a" tintColor="#04bbc5" barTintColor="white">
                    <TabBar.Item 
                        title="子帐号" 
                        key="Home" 
                        icon={iconHome}
                        selectedIcon={iconHomeSelected}
                        selected={selectedTab === 'homeTab'}
                        onPress={() => {
                            this.setState({
                                selectedTab: 'homeTab'
                            });
                        }}
                    >
                        <HomeOfDelegate delegateId={delegateId} tabName="homeTab"/>
                    </TabBar.Item>
                    <TabBar.Item
                        title="订单"
                        key="Order"
                        icon={iconOrder}
                        selectedIcon={iconOrderSelected}
                        selected={selectedTab === 'orderTab'}
                        onPress={() => {
                            this.setState({
                                selectedTab: 'orderTab'
                            });
                        }}
                    >  
                        <OrderOfDelegate delegateId={delegateId} tabName="orderTab"/>
                    </TabBar.Item>
                    <TabBar.Item
                        title="我的"
                        key="Mine"
                        icon={iconMine}
                        selectedIcon={iconMineSelected}
                        selected={selectedTab === 'mineTab'}
                        onPress={() => {
                            this.setState({
                                selectedTab: 'mineTab'
                            });
                        }}
                    >  
                        <DelegateMine delegateId={delegateId} tabName="mineTab"/>
                    </TabBar.Item>
                </TabBar>
            </div>
        )
    }
}

export default Delegate;


// WEBPACK FOOTER //
// ./src/modules/Delegate.js